module.exports = __webpack_public_path__ + "static/media/no-pupils.5b04fd70.png";